<template>
  <v-layout wrap justify-center>
    <v-flex xs12 class="px-0">
      <v-subheader class="amber blue-grey--text text--darken-4 px-2 py-3 font-weight-bold">航空手配</v-subheader>
    </v-flex>
    <v-flex xs12>
      <v-combobox v-model="form.flight.status"
        label="手配しますか？"
        :items="getFlightStatusItems"
      />
    </v-flex>
    <v-flex xs12 class="px-0">
      <v-subheader class="amber blue-grey--text text--darken-4 px-2 py-3 font-weight-bold">保険手配</v-subheader>
    </v-flex>
    <v-flex xs12>
      <v-combobox v-model="form.insurance.status"
        label="手配しますか？"
        :items="getInsuranceStatusItems"
      />
    </v-flex>
    <v-flex xs12 class="px-0">
      <v-subheader class="amber blue-grey--text text--darken-4 px-2 py-3 font-weight-bold">査証手配</v-subheader>
    </v-flex>
    <v-flex xs12>
      <v-combobox v-model="form.visa.status"
        label="手配しますか？"
        :items="getVisaStatusItems"
        @change="changeStatus('visa')"
      />
    </v-flex>
    <v-flex xs12 v-if="!['', '不要'].includes(form.visa.status)">
      <v-combobox v-model="form.visa.type" ref="visaType"
        label="ビザの種類は何ですか？"
        :items="getVisaTypeItems"
      />
    </v-flex>
    <v-flex v-if="form.visa.status === '当社手配'">
      <v-checkbox v-model="form.visa.local" ref="visaLocal"
        color="blue darken-2"
        label="現地で申請する"></v-checkbox>
    </v-flex>
    <v-flex xs12 class="px-0">
      <v-subheader class="amber blue-grey--text text--darken-4 px-2 py-3 font-weight-bold">送迎手配</v-subheader>
    </v-flex>
    <v-flex xs12>
      <v-combobox v-model="form.pickup.status"
        label="手配しますか？"
        :items="getPickupStatusItems"
        @change="changeStatus('pickup')"
      />
    </v-flex>
    <v-flex xs12 v-if="['外部手配', '現地サポーター'].includes(form.pickup.status)">
      <v-text-field v-model="form.pickup.name" ref="pickupName"
        label="手配先/サポーター名"></v-text-field>
    </v-flex>
    <v-flex xs12 v-if="['学校手配', '外部手配', '現地サポーター'].includes(form.pickup.status)">
      <p class="grey--text text--darken-1 caption text-xs-left">片道ですか往復ですか？</p>
      <v-radio-group v-model="form.pickup.type" ref="pickupType">
        <v-radio v-for="(item, key) in getPickupTypeItems" :key="key"
          color="blue darken-2"
          :label="item"
          :value="item"></v-radio>
      </v-radio-group>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'arrangementsForm',
  data () {
    return {
      config: {
        datepicker: {
          start: false,
          end: false
        }
      },
      form: {
        id: '',
        flight: {
          status: ''
        },
        insurance: {
          status: ''
        },
        visa: {
          status: '',
          type: '',
          local: ''
        },
        pickup: {
          status: '',
          type: '',
          name: ''
        }
      },
      rules: {
        title: [ v => !!v || '必須項目です' ]
      }
    }
  },
  methods: {
    init: function (req) {
      const { values } = req
      this.$set(this, 'form', values ? {
        id: values.id ? values.id : ('arrangements_' + new Date().getTime().toString(16) + Math.floor(1000 * Math.random()).toString(16)),
        flight: {
          status: (values.flight && values.flight.status) ? values.flight.status : ''
        },
        insurance: {
          status: (values.insurance && values.insurance.status) ? values.insurance.status : ''
        },
        visa: {
          status: (values.visa && values.visa.status) ? values.visa.status : '',
          type: (values.visa && values.visa.type) ? values.visa.type : '',
          local: (values.visa && values.visa.local) ? values.visa.local : ''
        },
        pickup: {
          status: (values.pickup && values.pickup.status) ? values.pickup.status : '',
          type: (values.pickup && values.pickup.type) ? values.pickup.type : '',
          name: (values.pickup && values.pickup.name) ? values.pickup.name : ''
        }
      } : {
        id: ('arrangements_' + new Date().getTime().toString(16) + Math.floor(1000 * Math.random()).toString(16)),
        flight: {
          status: ''
        },
        insurance: {
          status: ''
        },
        visa: {
          status: '',
          type: '',
          local: ''
        },
        pickup: {
          status: '',
          type: '',
          name: ''
        }
      })
    },
    getForm: function () {
      return this.form
    },
    changeStatus: function (type) {
      if (type === 'visa') {
        this.$set(this.form, 'visa', {
          status: this.form.visa.status,
          type: this.$refs.visaType ? this.form.visa.type : '',
          local: this.$refs.visaLocal ? this.form.visa.local : ''
        })
      } else if (type === 'pickup') {
        this.$set(this.form, 'pickup', {
          status: this.form.pickup.status,
          type: this.$refs.pickupType ? this.form.pickup.type : '',
          name: this.$refs.pickupName ? this.form.pickup.name : ''
        })
      }
    }
  },
  computed: {
    getFlightStatusItems () {
      return Object.keys(this.$meta.apply.flight.status).map(key => {
        return this.$meta.apply.flight.status[key]
      })
    },
    getInsuranceStatusItems () {
      return Object.keys(this.$meta.apply.insurance.status).map(key => {
        return this.$meta.apply.insurance.status[key]
      })
    },
    getVisaStatusItems () {
      return Object.keys(this.$meta.apply.visa.status).map(key => {
        return this.$meta.apply.visa.status[key]
      })
    },
    getVisaTypeItems () {
      return ['観光', '学生', 'ワーキングホリデー']
    },
    getPickupStatusItems () {
      return Object.keys(this.$meta.apply.pickup.status).map(key => {
        return this.$meta.apply.pickup.status[key]
      })
    },
    getPickupTypeItems () {
      return ['片道', '往復']
    }
  }
}
</script>